import { createContext, useEffect, useState } from "react";
import api from "../service/api";

export const SponsorContext = createContext();

export function SponsorProvider({ children }) {
  const [sponsors, setSponsors] = useState([]);
  const [insertSponsorLoading, setInsertSponsorLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const addSponsor = async (data) => {
    setInsertSponsorLoading(true);
    api
      .post("/sponsors", data)
      .then((response) => setSponsors({ ...sponsors, ...response.data }))
      .catch(e => console.log("Erro ao salvar parceiro:", e.message))
      .finally(() => setInsertSponsorLoading(false));
  };

  const deleteSponsor = async (id) => {
    setDeleteLoading(true);
    api
      .delete(`/sponsors/${id}`)
      .catch(e => console.log("Erro ao deletar parceiro:", e.message))
      .finally(() => setDeleteLoading(false));
  };

  const editSponsor = async (id, data) => {
    setInsertSponsorLoading(true);
    api
      .patch(`/sponsors/${id}`, data)
      .catch(e => console.log("Erro ao editar parceiro:", e.message))
      .finally(() => setInsertSponsorLoading(false));
  };

  const getSponsors = async () => {
    api
      .get("/sponsors")
      .then((response) => {
        console.log("Sponsors API Response:", response.data);
        const data = Array.isArray(response.data.data) ? response.data.data.sort((a, b) => a.id > b.id) : [];
        setSponsors(data);
      })
      .catch(e => console.log("Erro ao buscar parceiros:", e.message));
  };

  useEffect(() => {
    if (!insertSponsorLoading || !deleteLoading) getSponsors();
  }, [insertSponsorLoading, deleteLoading]);

  return (
    <SponsorContext.Provider
      value={{
        sponsors,
        insertSponsorLoading,
        setInsertSponsorLoading,
        deleteLoading,
        addSponsor,
        deleteSponsor,
        editSponsor,
        getSponsors,
      }}
    >
      {children}
    </SponsorContext.Provider>
  );
}
